import React from "react";

import PropTypes from "prop-types";

import styles from "./ModalWrapper.scss";

/**
 *
 * * Comments for parameters
 *
 * @param {boolean} smallModalFlag Boolean flag to change the Modal Style
 *
 **/

const ModalWrapper = ({ children, smallModalFlag, modalWidth }) => {
  return (
    <div
      className={
        smallModalFlag
          ? styles["modal-container-alt"]
          : styles["modal-container"]
      }
      style={{ width: modalWidth }}
    >
      {children}
    </div>
  );
};

export default ModalWrapper;

ModalWrapper.defaultProps = {
  smallModalFlag: false,
  modalWidth: ""
};

ModalWrapper.propTypes = {
  smallModalFlag: PropTypes.bool,
  modalWidth: PropTypes.string
};
